import {
  isWebsiteLoaded,
  selectWebsite,
} from './../../../../../shared/store/_features/website/website.selector';
import { WebsiteModel } from './../../portal.model';
import { Title } from '@angular/platform-browser';
import {
  PortalViewPageStatusEnum,
  SharedPortalViewService,
} from './../shared-portal-view.service';
import {
  Component,
  OnInit,
  Renderer2,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthenticationService } from '../../../../../shared/services/authentication.service';
import { ApiService } from '../../../../../shared/services/lsg.api.service';
import {
  UserWebsites,
  UserWebsite,
  MailServiceStatus,
} from '../../portal.model';
import { User } from 'src/app/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { Route } from '@angular/router';
import { PromptingService } from 'src/app/shared/services';
import { PageItem } from 'src/app/models/portal';
import { last, map } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  query,
  stagger,
  keyframes,
} from '@angular/animations';
import { Observable, from, lastValueFrom, of } from 'rxjs';
import {
  TransitionGroupComponent,
  TransitionGroupItemDirective,
} from 'src/app/directives/transition-group-item.directive';
import { UserDashboardService } from '../../../../../shared/services/user-dashboard.service';
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';
import { Store } from '@ngrx/store';

export enum PortalNavigatorEnum {
  site_settings,
  pages,
  site_apperances,
}

export enum PagesFilterNavigatorEnum {
  all,
  published,
  draft,
}
@Component({
  templateUrl: './portal-view-page.component.html',
  styleUrls: ['./portal-view-page.component.css'],
  animations: [
    trigger('divStateDraft', [
      state(
        'in',
        style({ backgroundColor: 'red', transform: 'translateX(0)' }),
      ),

      transition('void => *', [
        animate(
          1000,
          keyframes([
            style({ opacity: 0, transform: 'translateY(-100%)' }),
            style({ opacity: 1, transform: 'translateY(15px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ]),
        ),
      ]),
      transition('* => void', [
        animate(
          500,
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 0, transform: 'translateY(100%)' }),
          ]),
        ),
      ]),
    ]),
    trigger('divState', [
      state(
        'in',
        style({ backgroundColor: 'red', transform: 'translateX(0)' }),
      ),

      transition('void => *', [
        animate(
          1000,
          keyframes([
            style({ opacity: 0, transform: 'translateY(-100%)' }),
            style({ opacity: 1, transform: 'translateY(15px)' }),
            style({ opacity: 1, transform: 'translateY(0)' }),
          ]),
        ),
      ]),
      transition('* => void', [
        animate(
          0,
          keyframes([
            style({ opacity: 1, transform: 'translateY(0)' }),
            style({ opacity: 1, transform: 'translateY(-15px)' }),
            style({ opacity: 0, transform: 'translateY(100%)' }),
          ]),
        ),
      ]),
    ]),
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0s ease-in', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class PortalViewMainPageComponent implements OnInit, OnDestroy {
  // NGRX
  website$: Observable<WebsiteModel>;
  isWebsiteLoaded$: Observable<boolean>;

  //
  portalViewPageStatusEnum = PortalViewPageStatusEnum;
  scrollSidebar: boolean = false;

  id: number;
  // loaded = false;
  pagesFilterNavigator: PagesFilterNavigatorEnum = PagesFilterNavigatorEnum.all;
  loadingPortals = true;

  userWebsites: UserWebsites;
  currentUser: User;
  portals: any;

  shareArr: boolean[];
  error: any;
  asideStatus = false;

  timeZoneOffset: string;

  subscribeFormURL: string;
  currentPage: PortalNavigatorEnum = PortalNavigatorEnum.pages;
  constructor(
    private renderer: Renderer2,
    private route: Router,
    private aroute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private api: ApiService,
    private userDashboardService: UserDashboardService,
    public sharedPortalViewService: SharedPortalViewService,
    private title: Title,
    private sharedOwnerDashboardService: SharedOwnerDashboardService,
    private store: Store,
    private prompting: PromptingService,
  ) {
    this.website$ = this.store.select(selectWebsite);
    this.isWebsiteLoaded$ = this.store.select(isWebsiteLoaded);

    // this.sharedPortalViewService.getPaymentMethods();
  }

  ngOnDestroy(): void {
    // if (!this.userDashboardService.isMobile) {
    //   this.userDashboardService.deactivateFocusMode();
    // }
    this.sharedPortalViewService.currentWebsite?.website?.domains?.customdomains.forEach(
      (domain) => {
        if (!!domain?.process?.timeout) {
          clearTimeout(domain.process.timeout);
        }
      },
    );
  }

  async ngOnInit() {
    // if (this.userDashboardService.isMobile) {
    //   this.userDashboardService.closeMobileCollapse();
    // } else {
    //   this.userDashboardService.activateFocusMode();
    // }
    await this.sharedPortalViewService.getCurrentWebsite();

    this.generateWebsiteNavigationMenu();

    this.sharedOwnerDashboardService.setTitle({
      main: 'Website',
      sub: `Your website's identity, logo, primary color, pages, and payment methods are essential for creating a great customer experience. Manage them all here.`,
    });
    // this.sharedOwnerDashboardService.setBreadcrumbs({customBreadCrumbs: [{label: 'Products'}]})
    this.sharedOwnerDashboardService.setBreadcrumbs({ base: 'website' });
  }

  generateWebsiteNavigationMenu(
    currentWebsite: WebsiteModel = this.sharedPortalViewService.currentWebsite
      .website,
  ) {
    // let OfferCount = !!currentWebsite?.offers?.length ? currentWebsite.offers.length : '0';

    this.sharedPortalViewService.websitePageNavigations = [
      {
        label: 'Overview',
        url: `/dashboard/website/overview`,
        iconPath: 'assets/images/svg/system/overview.svg',
        customId: 'portal-overview',
      },
      {
        label: 'Site Identity',
        url: `/dashboard/website/site-identity`,
        iconPath: 'assets/images/svg/system/overview.svg',
        customId: 'portal-overview',
      },
      {
        label: 'Branding',
        url: `/dashboard/website/branding`,
        iconPath: 'assets/images/svg/system/overview.svg',
        customId: 'portal-overview',
      },
      // {
      //   label: 'Design & Branding',
      //   url: `/dashboard/website/branding`,
      //   iconPath: 'assets/images/svg/system/overview.svg',
      //   customId: 'portal-overview',
      // },
      // {
      //   label: 'Design',
      //   url: `/dashboard/website/design`,
      //   iconPath: 'assets/images/svg/system/overview.svg',
      //   customId: 'portal-overview',
      // },
      {
        label: 'Pages',
        url: `/dashboard/website/content`,
        iconPath: 'assets/images/svg/system/domain.svg',
        customId: 'portal-content',
        subMenu: [
          {
            label: 'Website Pages',
            url: '/dashboard/website/content/pages',
          },
          {
            label: 'Sales Funnels',
            url: '/dashboard/website/content/funnels',
          },
        ],
      },
      // {
      //   label: 'Blog',
      //   url: `/dashboard/website/blog`,
      //   iconPath: 'assets/images/svg/system/settings.svg',
      //   customId: 'portal-blog',
      // },

      {
        label: 'Settings',
        url: `/dashboard/website/settings`,
        iconPath: 'assets/images/svg/system/settings.svg',
        customId: 'portal-settings',
        helpText:
          'Website settings section, where you can explore and adjust all your primary settings, including payments, domains, and mailing.',
        subMenu: [
          {
            label: 'Domains',
            url: '/dashboard/website/settings/domains',
          },
          // {
          //   label: 'Navigation',
          //   url: `/dashboard/website/settings/navigation`,
          // },

          {
            label: 'Mailing',
            url: '/dashboard/website/settings/mailing',
          },
        ],
      },
    ];
  }

  public backToDashboard() {
    this.route.navigate(['dashboard', 'portal']);
  }

  // submitNewsletterForm(url: string) {
  //   this.subscribeFormURL = this.encodeRedirect(
  //     'https://' + this.sharedPortalViewService.currentWebsite.website.domain + url
  //   );
  //   setTimeout(() => {
  //     const myform = document.getElementById(
  //       'subscribersListForm'
  //     ) as HTMLFormElement;
  //     myform.submit();
  //   }, 500);
  // }

  // submitMyPageForm(i) {
  //   const myform = document.getElementById(i) as HTMLFormElement;
  //   myform.submit();
  // }

  encodeRedirect(url) {
    return encodeURIComponent(url);
  }

  deleteSiteErrorAlert(index: number) {
    this.prompting
      .confirm(
        {
          allowOutsideClick: false,
          input: 'checkbox',
          inputPlaceholder:
            'I confirm that I want to Delete My Current Portal.',
          title: 'You’re about to Delete your Portal',
          html:
            "<br><span style='font-size:1.2em'>Are you sure you want to Delete</span><br>" +
            this.sharedPortalViewService.currentWebsite.website.siteUrl +
            "<br><span class='badge badge-danger' style='text-transform:uppercase'><i class='fa fa-trash text-white'></i> this step cannot be undone</span>.",
          icon: 'warning',
          confirmButtonText: 'Delete',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return lastValueFrom(
              this.api.deleteWebsite(
                this.sharedPortalViewService.currentWebsite.website.id.toString(),
              ),
            ).then(async (resultFromReq: any) => {
              if (resultFromReq && resultFromReq.deleted) {
                return await this.deleteWebsite(index);
              }
              return undefined;
            });
          },
          cancelButtonText: 'Cancel',
          inputValidator: (result) => {
            return !result && 'You need to agree';
          },
          didOpen: () => {
            const confirmButton =
              this.prompting.getConfirmButton() as HTMLButtonElement;
            const checkbox = this.prompting.getInput() as HTMLInputElement;

            if (confirmButton && checkbox) {
              confirmButton.disabled = !checkbox.checked;
              checkbox.addEventListener('change', () => {
                confirmButton.disabled = !checkbox.checked;
              });
            }
          },
          isDanger: true,
        },
        'md',
      )
      .then((res) => {
        if (res.isConfirmed) {
          this.userWebsites.websites.splice(index, 1);
          this.route.navigate(['dashboard', 'portal']);
        }
      });
  }

  toggleAside() {
    this.asideStatus = !this.asideStatus;
    if (this.asideStatus === true) {
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    } else {
      this.renderer.removeStyle(document.body, 'overflow');
    }
  }

  closeAside() {
    this.asideStatus = false;
    this.renderer.removeStyle(document.body, 'overflow');
  }

  private deleteWebsite(index: number): Promise<boolean> {
    const promise: Promise<boolean> = new Promise((resolve) => {
      const x = new XMLHttpRequest();
      x.timeout = 15000;
      x.open(
        'GET',
        'https://cors-anywhere.herokuapp.com/https://' +
          this.sharedPortalViewService.currentWebsite.website.siteUrl,
      );
      x.onreadystatechange = () => {
        if (x.readyState === 4) {
          setTimeout(() => {
            if (this.sharedPortalViewService.currentWebsite.website) {
              x.open(
                'GET',
                'https://cors-anywhere.herokuapp.com/https://' +
                  this.sharedPortalViewService.currentWebsite.website.siteUrl,
              );
              x.send();
            }
          }, 5000);
          if (x.status === 200) {
          } else {
            resolve(true);
          }
        }
      };
      x.send();
    });

    return promise;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollOffset =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollOffset >= 90) {
      this.scrollSidebar = true;
    } else {
      this.scrollSidebar = false;
    }
  }
}
